// [ai] What a trusted module may import: the app's OWN React (one instance, so hooks and contexts work) and the SDK.
// app/lib/views.ALIASES rewrites `react`, `react/jsx-runtime`, `react-dom`, `@atlas/sdk` to /sdk/*.js at compile time; those
// shims (app/web/public/sdk) re-export from globalThis.__atlas, which main.tsx sets before any module can load.
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as jsx from "react/jsx-runtime";
import { AtlasContext, useAtlas } from "./react";
export const VENDOR = { react: React, "react-dom": ReactDOM, "react/jsx-runtime": jsx, "@atlas/sdk": { useAtlas, AtlasContext } };
export type Vendor = typeof VENDOR;
export function exposeVendor(g: { __atlas?: Vendor } = globalThis as { __atlas?: Vendor }): void { g.__atlas = VENDOR; }
